export const contactUsContent = {
  newCallModalHeading: 'Contact Your HR Manager',
  callNowOptionTitle: 'Call Now',
  callNowCta: 'Call Now',
  callNowPhoneNumber: '(855) 609-0031',
  callNowResponseTime: 'Immediate',
  callNowDescription:
    '<p>Speak directly with your dedicated HR Manager about any workplace issue.</p>',
  scheduleDedicatedHrCallTitle: 'Schedule a Call',
  scheduleACallCta: 'Schedule',
  scheduledCallResponseTime: 'Within 24 hours',
  businessHours: 'Monday - Friday, 6:00 AM - 6:00 PM PST',
  newRequestModalHeading: 'New Request',
  chatNowOptionTitle: 'Chat Now',
  chatNowResponseTime: 'Within minutes',
  chatNowCta: 'Start Chat',
  chatNowConfirmationModalTitle: 'Chat Request Sent',
  dedicatedHrOptionTitle: 'Send a Request',
  requestResponseTime: 'Within 24 hours',
  sendRequestCta: 'Send Request',
  dedicatedHrRequestConfirmationModalTitle: 'Request Submitted',
  requestSubmittedConfirmation: 'Your request has been submitted successfully.',
  callCustomerSupportInstruction: 'For technical support, call us directly.',
  customerSupportPhoneNumber: '(855) 609-0031',
  customerSupportCallCta: 'Call Support',
  employeeConfidentialityWarning:
    'Your conversation is confidential and will not be shared with your employer.',
  chatNowRequestConfirmationText:
    '<p>Your chat request has been submitted. A team member will be with you shortly.</p>',
  dedicatedHrRequestDescription:
    '<p>Submit a request to your dedicated HR Manager for personalized assistance with any HR issue.</p>',
  dedicatedHrRequestConfirmationText:
    '<p>Your request has been submitted successfully. Your dedicated HR Manager will respond within 24 hours.</p>',
  customerSupportCallText:
    '<p>Our customer support team is available during business hours to help with any technical issues.</p>',
};

export default contactUsContent;
